import { mergeDeepRight as merge } from 'ramda';
import * as R from 'ramda';

import actionTypes, { REMOVE_IMAGE, RESET_COMPRESSED_IMAGES } from '../actions/actionTypes';


function compressedImages(state={}, action) {
  const { payload, type} = action;
  switch (type) {
    case actionTypes.IMAGE_COMPRESSION_DONE:
        let compressedImages = R.clone(state.compressedImages || []);
        compressedImages = [...compressedImages, ...payload.compressedImages];
        state = { ...state, compressedImages: compressedImages};
      return state;
    case REMOVE_IMAGE:
        let allImages = R.clone(state.compressedImages || []);
        if(payload.currentIndex >= 0 ) {
            allImages.splice(payload.currentIndex, 1);
        } 
        state = { ...state, compressedImages: allImages};
        return state;
    case RESET_COMPRESSED_IMAGES:
        return {...state, compressedImages: []};
    default:
      return state;
  }
};

export default compressedImages;
